"use client";

import { useActionState, useTransition } from "react";
import type { FormState } from "./actions";

/**
 * Runs a server action from a form without the form being reset afterwards.
 * `<form action={fn}>` makes React 19 clear every uncontrolled field once the
 * action returns, so a validation error would also throw away what the person
 * had just typed (and a chosen file). Submitting through onSubmit keeps it all.
 */
export function useFormAction(action: (prev: FormState, fd: FormData) => Promise<FormState>) {
  const [state, run, pending] = useActionState(action, null);
  const [, start] = useTransition();
  function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    start(() => run(data));
  }
  return [state, onSubmit, pending] as const;
}
